<template>
  <div>
    <div v-if="tokenError" class="text-center">
      <h1>{{ tokenErrorText.title }}</h1>
      <div>{{ tokenErrorText.text }}</div>
    </div>
    <template v-else-if="readyUI && readyUser">
      <v-snackbar v-model="savedUserOnRedirect" :timeout="4000" color="success" :bottom="true">{{ uiTexts.updatedText }}</v-snackbar>
      <v-card class="text-center app" outlined>
        <v-img :src="uiConfig.logo" :width="uiConfig.logoWidth || `6rem`" class="image"></v-img>
        <v-list class="d-flex inputs fixedWidth">
          <div>
            <h3 class="headline mb-0" style="padding-bottom: 0.5rem">
              {{ uiTexts.title }}
              <br />
              <small style="color: rgb(132, 132, 132)">{{ uiTexts.customerName }}</small>
              <br />
              <small>{{ uiTexts.subtitle }}</small>
            </h3>
          </div>
          <div class="input">
            <span v-text="uiTexts.emailLabel"></span>
            <v-text-field class="input-field" v-model="userState.email" :disabled="true" append-icon="account_box"></v-text-field>
          </div>
          <div class="input">
            <span v-text="uiTexts.firstNameLabel"></span>
            <v-text-field class="input-field" v-model="userState.first_name" :disabled="!uiConfig.enableNameFields" append-icon="face"></v-text-field>
          </div>
          <div class="input">
            <span v-text="uiTexts.lastNameLabel"></span>
            <v-text-field class="input-field" v-model="userState.last_name" :disabled="!uiConfig.enableNameFields"></v-text-field>
          </div>
          <div class="input">
            <span v-text="uiTexts.languageLabel"></span>
            <v-select
              class="input-field"
              :items="languages"
              item-text="name"
              item-value="code"
              v-model="userState.language"
              :disabled="!uiConfig.enableLanguageSelects"
              append-icon="language"
            ></v-select>
          </div>
          <div class="input" v-if="uiConfig.enableAdression">
            <span v-text="uiTexts.adressionLabel"></span>
            <v-select
              class="input-field"
              :items="this.uiConfig.adressions"
              item-text="displayName"
              item-value="id"
              v-model="userState.form_of_address"
            ></v-select>
          </div>
          <div class="input" v-if="uiConfig.enableDobField">
            <span v-text="dobConfigs.fieldLabel"></span>
            <v-menu ref="dobMenu" v-model="dobMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dobFormatted"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  class="input-field"
                  clearable
                  @click:append="dobMenu = !dobMenu"
                  @click:clear="userState.dob = null"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="dobPicker"
                v-model="userState.dob"
                :max="new Date().toISOString().substr(0, 10)"
                @change="save"
                :locale="locale"
                :color="dobConfigs.color"
                :first-day-of-week="dobConfigs.firstDayOfWeek === 'monday' ? 1 : 0"
              ></v-date-picker>
            </v-menu>
          </div>
          <div class="input" v-if="uiConfig.enablePhoneField">
            <span v-text="phoneConfigs.fieldLabel"></span>
            <vue-phone-number-input
              v-model="userState.phone"
              @update="onUpdatePhoneNumber"
              :default-country-code="phoneConfigs.defaultCountryCode"
              :preferred-countries="phoneConfigs.preferredCountries"
              :only-countries="phoneConfigs.onlyCountries"
              :disabled="phoneIsDisabled"
              :translations="phoneLabels"
              :clearable="true"
              :error="phoneError"
              class="input-field"
              style="margin-top: 0.5rem"
            />
          </div>
          <v-alert :value="phoneError" type="error">{{ phoneConfigs.errorMessage }}</v-alert>
          <div class="input" :style="uiConfig.enablePhoneField ? 'margin-top:1.5rem' : ''">
            <span v-text="uiTexts.genderLabel"></span>
            <v-radio-group v-model="userState.gender" :column="false" class="input-field">
              <v-radio :label="uiTexts.genderFemale" value="F"></v-radio>
              <v-radio :label="uiTexts.genderMale" value="M"></v-radio>
              <v-radio :label="uiTexts.genderUndefined" value="P"></v-radio>
            </v-radio-group>
          </div>
          <v-switch class="fixedWidth" @change="susbscribeChanged" :label="uiTexts.mailOptionsLabel" v-model="subscribeState"></v-switch>
          <div v-if="userState.subscriptions.length > 1" style="width: 90%">
            <div v-for="(subscription, i) in userState.subscriptions" :key="i">
              <v-switch
                class="fixedWidth"
                :label="subscription.name"
                v-model="subscription.email_subscribe"
                @change="customerSubscriptionChanged($event, subscription.id)"
              ></v-switch>
              <div>
                <div v-for="(option, j) in userState.subscriptions[i].options" :key="j" class="option">
                  <v-switch
                    v-model="option.value"
                    class="fixedWidth"
                    :label="option.name"
                    @change="customerOptionChanged($event, userState.subscriptions[0].id, option.id)"
                  >
                    <v-tooltip top v-if="option.description" slot="append">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="grey" v-on="on" v-bind="attrs"> info </v-icon>
                      </template>
                      <span>{{ option.description }}</span>
                    </v-tooltip>
                  </v-switch>
                  <div v-if="option.suboptions.length > 0" class="suboption-container">
                    <div v-for="(suboption, k) in option.suboptions" :key="k" class="suboption">
                      <v-checkbox
                        v-model="suboption.value"
                        :label="suboption.name"
                        hide-details
                        class="chckbx_dense"
                        @change="customerOptionChanged($event, userState.subscriptions[0].id, suboption.id)"
                      >
                        <v-tooltip top v-if="suboption.description" slot="append">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="grey" v-on="on" v-bind="attrs">info</v-icon>
                          </template>
                          <span>{{ suboption.description }}</span>
                        </v-tooltip>
                      </v-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <span class="fixedWidth">
                <v-divider v-if="i < userState.subscriptions.length - 1"></v-divider>
              </span>
            </div>
          </div>
          <div v-else-if="userOptions != undefined" style="width: 90%">
            <div v-for="(option, j) in userState.subscriptions[0].options" :key="j" class="option">
              <v-switch
                v-model="option.value"
                class="fixedWidth"
                :label="option.name"
                @change="customerOptionChanged($event, userState.subscriptions[0].id, option.id)"
              >
                <v-tooltip top v-if="option.description" slot="append">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="grey" v-on="on" v-bind="attrs"> info </v-icon>
                  </template>
                  <span>{{ option.description }}</span>
                </v-tooltip>
              </v-switch>
              <div v-if="option.suboptions.length > 0" class="suboption-container">
                <div v-for="(suboption, k) in option.suboptions" :key="k" class="suboption">
                  <v-checkbox
                    v-model="suboption.value"
                    :label="suboption.name"
                    hide-details
                    class="chckbx_dense"
                    @change="customerOptionChanged($event, userState.subscriptions[0].id, suboption.id)"
                  >
                    <v-tooltip top v-if="suboption.description" slot="append">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="grey" v-on="on" v-bind="attrs">info</v-icon>
                      </template>
                      <span>{{ suboption.description }}</span>
                    </v-tooltip>
                  </v-checkbox>
                </div>
              </div>
            </div>
          </div>
          <v-btn :loading="sendUserState.loading" @click="sendUser" style="margin-top: 1rem">{{ uiTexts.submitLabel }}</v-btn>
          <div>
            <v-alert :value="sendUserState.error" type="error">{{ uiTexts.messageFailure }}</v-alert>
            <v-alert :value="sendUserState.done" type="success">{{ uiTexts.messageSuccess }}</v-alert>
          </div>
        </v-list>
      </v-card>
      <br /><br /><br />
      <v-footer v-if="uiTexts && uiConfig">
        <v-col class="text-center">
          <span v-html="uiConfig.aboutText"></span>
          <br />
          <br />
          <span v-html="uiConfig.poweredByText"></span>
        </v-col>
      </v-footer>
    </template>
    <template v-else>
      <loader></loader>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import gql from "graphql-tag";
import jwt from "jsonwebtoken";
import { setTimeout } from "timers";
const countryCodes = require("../assets/CountryCodes.json");
export default {
  apollo: {
    Config: {
      query: gql`
        # Write your query or mutation here
        query UIData($locale: String, $mandator: String!) {
          Config(mandator: $mandator, locale: $locale) {
            logo
            logoWidth
            url
            enableAdression
            enableLanguageSelects
            enableNameFields
            enablePhoneField
            phoneConfigs {
              fieldLabel
              countrySelectorLabel
              phoneNumberLabel
              exampleLabel
              errorMessage
              defaultCountryCode
              preferredCountries
              onlyCountries
              editable
            }
            enableDobField
            dobConfigs {
              fieldLabel
              firstDayOfWeek
              color
              dateFormat
            }
            favicon
            aboutText
            poweredByText
            adressions {
              id
              displayName
            }
            userOptions {
              brazeId
              displayField
              displayDescription
            }
            subscribedChecksUserOptions
            texts {
              title
              pageTitle
              customerName
              subtitle
              messageSuccess
              messageSaving
              messageFailure
              updatedText
              infoText
              emailLabel
              firstNameLabel
              lastNameLabel
              languageLabel
              genderLabel
              genderMale
              genderFemale
              genderUndefined
              mailOptionsLabel
              submitLabel
              adressionLabel
            }
          }
          Languages(mandator: $mandator, locale: $locale) {
            name
            code
          }
        }
      `,
      variables() {
        // Use vue reactive properties here
        return {
          locale: this.locale,
          mandator: this.mandator,
        };
      },

      result({ data }) {
        if (data) {
          this.$set(this, "config", data.Config);
          this.$set(this, "languages", data.Languages);
          setTimeout(() => this.$emit("updateHead"), 100);
        }
      },
    },
  },
  data() {
    return {
      dobMenu: false,
      languages: null,
      config: null,
      locale: null,
      mandator: null,
      tokenError: false,
      timeoutError: false,
      sendUserState: {
        loading: false,
        status: "",
        error: null,
        done: false,
      },
      userState: {
        email: "",
        first_name: "",
        last_name: "",
        language: "",
        addression: "",
        gender: "",
        phone: "",
        dob: "",
        subscriptions: [],
      },
      subscribeState: false,
      readyUI: false,
      readyUser: false,
      token: null,
      token_data: null,
      savedUserOnRedirect: false,
      phone: null,
      phoneError: false,
    };
  },
  head: {
    title: function () {
      if (this.uiTexts) {
        return {
          inner: this.uiTexts.pageTitle || this.uiTexts.title || "",
          separator: "",
          complement: this.uiTexts.customerName,
        };
      }
    },
  },
  watch: {
    Config() {
      if (this.languages && this.config) {
        this.readyUI = true;

        this.$setIcon(this.uiConfig.favicon);
      } else {
        this.readyUI = false;
      }
    },
    readyUI() {
      if (this.readyUI) {
        this.loadUser();
      }
    },
    timeoutError() {
      if (this.timeoutError) this.pushToResend();
    },
    dobMenu(val) {
      val && setTimeout(() => (this.$refs.dobPicker.activePicker = "YEAR"));
    },
  },
  computed: {
    uiTexts() {
      if (this.config) return this.config.texts;
    },

    uiConfig() {
      if (this.config) return this.config;
    },
    userOptions() {
      if (this.uiConfig && this.uiConfig.userOptions) return this.uiConfig.userOptions;
      else return [];
    },
    phoneConfigs() {
      if (this.config && this.config.phoneConfigs) {
        return this.config.phoneConfigs;
      } else {
        return {};
      }
    },
    dobConfigs() {
      if (this.config && this.config.dobConfigs) {
        return this.config.dobConfigs;
      } else {
        return {};
      }
    },
    phoneLabels() {
      if (this.config && this.config.phoneConfigs) {
        let phoneConfigs = this.config.phoneConfigs;
        return {
          countrySelectorLabel: phoneConfigs.countrySelectorLabel,
          phoneNumberLabel: phoneConfigs.phoneNumberLabel,
          example: phoneConfigs.exampleLabel,
        };
      } else {
        return {};
      }
    },
    phoneIsDisabled() {
      if (this.config && this.config.phoneConfigs) {
        return !this.config.phoneConfigs.editable;
      } else {
        return false;
      }
    },
    tokenErrorText() {
      switch (this.locale) {
        case "de":
          return {
            title: "Ein Fehler ist aufgetreten",
            text: "Es scheint ein Problem mit dem Link zu geben. Bitte versuchen Sie es später erneut.",
          };
        default:
          //english
          return {
            title: "An error occured",
            text: "There is a problem with the link. Please try again later.",
          };
      }
    },
    dobFormatted: {
      get() {
        if (this.userState.dob) {
          const [year, month, day] = this.userState.dob.split("-");
          const format = this.dobConfigs.dateFormat;
          switch (format) {
            case "DD/MM/YYYY":
              return `${day}/${month}/${year}`;
            case "DD-MM-YYYY":
              return `${day}-${month}-${year}`;
            case "YYYY/MM/DD":
              return `${year}/${month}/${day}`;
            case "YYYY-MM-DD":
              return `${year}-${month}-${day}`;
            default:
              return `${year}-${month}-${day}`;
          }
        } else {
          return "";
        }
      },
      set() {},
    },
  },
  methods: {
    checkSubscribeState() {
      if (this.userState.subscriptions.every((s) => !s.email_subscribe)) this.subscribeState = false;
      else this.subscribeState = true;
    },
    customerSubscriptionChanged(val, subscriptionId) {
      const subscription = this.userState.subscriptions.find((s) => s.id === subscriptionId);
      subscription.email_subscribe = val;
      subscription.options.forEach((o) => this.changeOption(o, val));
      this.checkSubscribeState();
    },
    customerOptionChanged(val, subscriptionId, optionId) {
      const subscription = this.userState.subscriptions.find((s) => s.id === subscriptionId);

      subscription.options.forEach((o) => this.changeOption(o, val, optionId));

      if (subscription.options.some((o) => o.value)) subscription.email_subscribe = true;
      else if (subscription.options.every((o) => !o.value)) subscription.email_subscribe = false;
      this.checkSubscribeState();
    },
    susbscribeChanged(val) {
      this.userState.subscriptions.forEach((subscription) => {
        subscription.email_subscribe = val;
        subscription.options.forEach((o) => this.changeOption(o, val));
      });
    },
    changeOption(option, val, optionId) {
      if (optionId) {
        if (option.id == optionId) return this.changeOption(option, val);
        option.suboptions.forEach((o) => this.changeOption(o, val, optionId));
        if (option.suboptions.some((o) => o.value)) option.value = true;
        // else if (option.suboptions.every((o) => !o.value)) option.value = false;
      } else {
        option.value = val;
        option.suboptions.forEach((option) => this.changeOption(option, val));
      }
    },
    save(date) {
      this.$refs.dobMenu.save(date);
    },
    onUpdatePhoneNumber(payload) {
      this.phone = payload;
      if (payload.isValid || !payload.phoneNumber) {
        this.phoneError = false;
      }
    },
    pushToResend() {
      this.$router.push({ path: "resend", query: { jwt: this.token } });
    },
    async loadUser() {
      if (this.token) {
        try {
          var res = await this.axios.get("api/user/export", {
            headers: { Authorization: `Bearer ${this.token}` },
          });

          // no user returned -> something went wrong on server
          if (!res.data) {
            return this.pushToResend();
          }
          this.userState = res.data;
          console.log(this.userState);

          for (const s of this.userState.subscriptions) {
            if (this.config.subscribedChecksUserOptions) {
              s.email_subscribe = s.email_subscribe === "opted_in" || s.email_subscribe === "subscribed";
            } else {
              s.email_subscribe = s.email_subscribe === "opted_in";
            }
          }

          this.subscribeState = this.userState.subscriptions.some((s) => s.email_subscribe);

          // select country code based on phone number
          if (this.userState.phone) {
            let phone_number = this.userState.phone;
            for (let i = 0; i < countryCodes.length; i++) {
              let dial_code = countryCodes[i].dial_code;
              if (phone_number.startsWith(dial_code)) {
                this.phoneConfigs.defaultCountryCode = countryCodes[i].code;
                // remove dial code from phone number
                this.userState.phone = phone_number.slice(dial_code.length);
              }
            }
          }
          this.readyUser = true;
        } catch (e) {
          this.tokenError = true;
        }
      }
    },
    async sendUser() {
      this.sendUserState = {
        loading: true,
        status: "",
        error: null,
        done: false,
      };

      //check if phone Number is valid
      if (this.phone && this.phone.phoneNumber && !this.phone.isValid) {
        this.phoneError = true;
        this.sendUserState.loading = false;
        return false;
      } else {
        this.phoneError = false;
      }

      if (!this.token) {
        this.sendUserState.error = true;
        return this.pushToResend();
      }
      try {
        const subscriptions = [];
        for (const s of this.userState.subscriptions) {
          subscriptions.push({
            email_subscribe: s.email_subscribe ? "opted_in" : "unsubscribed",
            options: s.options,
            name: s.name,
            id: s.id,
          });
        }
        let phone = null;
        if (this.userState.phone && this.phone) {
          phone = this.phone.formattedNumber; // use formatted number for Braze
        }
        console.log("User:", this.userState);
        var res = await this.axios.post(
          "api/user/track",
          { ...this.userState, subscriptions, phone },
          {
            headers: { Authorization: `Bearer ${this.token}` },
          }
        );
        this.sendUserState.done = true;
      } catch (e) {
        console.log("Error sending user:", e);
        this.sendUserState.error = true;
        this.pushToResend();
      }

      this.sendUserState.loading = false;
    },
  },
  created() {
    this.token = this.$route.query.jwt;
    this.savedUserOnRedirect = this.$route.query.saved;
    this.locale = localStorage.locale || navigator.language;

    if (this.locale.length > 2) {
      this.locale = this.locale.split("-")[0];
    }
    if (!this.token) {
      this.tokenError = true;
    } else {
      try {
        this.$set(this, "token_data", jwt.decode(this.token));
        if (this.token_data.exp < Date.now() / 1000) {
          this.timeoutError = true;
        } else {
          this.mandator = this.token_data.mandator || this.token_data.mndt;
        }
      } catch (e) {
        this.tokenError = true;
      }
    }
  },
};
</script>
<style>
.app {
  margin-top: 0rem;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  padding: 2rem;
  padding-bottom: 2rem;
}

.v-alert {
  margin: 1rem;
  margin-top: 2rem;
  margin-bottom: 0rem;
}

.centered {
  padding: 0;
  margin-left: auto;
  margin-right: auto;
  align-self: center;
}

.inputs {
  flex-direction: column;
  align-items: center;
  vertical-align: middle;
}

.input {
  text-align: left;
  color: grey;
}

.input:focus-within {
  color: steelblue;
}

.input-field {
  width: 20rem;
  margin: 0;
  padding: 0;
}

.image {
  margin: 0.5rem;
}

.chckbx_dense {
  margin: 0rem;
  padding: 0rem;
  margin-bottom: 1px !important;
}

.fixedWidth {
  width: 20em;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  right: 0%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.v-radio {
  margin: 0.2rem;
}

.v-footer {
  background-color: #efefef;
  flex: 0 0 50px;
  /*or just height:50px;*/
  margin-top: auto;
}

.option {
  background-color: #f8f8f8;
  padding: 20px;
  border-radius: 16px;
  margin-bottom: 20px;
}

.suboption {
  background-color: white;
  padding: 20px;
  border-radius: 16px;
  margin-bottom: 20px;
}

.suboption-container > :last-child {
  margin-bottom: 0px;
}
</style>
